<div>
    <a role="link" (click)="openLink()" (keydown.enter)="openLink()" [attr.aria-expanded]="isLinkActive()" [style.color]="isHighContrast ? '#ff0' : ''" tabindex="0" style="display: flex; flex-direction: row; justify-content: flex-start">
            <i *ngIf="!element.isIconDisabled" class="fas fa-link" aria-hidden="true"></i>&nbsp;
            <!-- use tra-md for &nbsp; and other html rendering if needed -->
            <tra-md [isCondensed]="true" style="font-weight: normal; text-decoration:underline" [slug]="textLinkCaption"></tra-md>
            <render-image *ngIf="element.thumbNail" [element]="element.thumbNail"></render-image>
    </a>
</div>
